import React from 'react';
import { Swiper, Image, AutoCenter, Footer, List } from 'antd-mobile'
import './index.scss';
import { createFromIconfontCN } from '@ant-design/icons';


const Ay26 = () => {
    const token = JSON.parse(localStorage.getItem('cx315_token'))
    const params = JSON.parse(localStorage.getItem('atype2026'))


    const MyIcon = createFromIconfontCN({
        scriptUrl: '//at.alicdn.com/t/c/font_5169486_apm3rxyzekh.js', // 在 iconfont.cn 上生成
    });

    return <>
        {/* http://d.ddspp.com:30123/v3/v3/1000_1777353244#sc*/}
        <Swiper autoplay>
            <Swiper.Item key={`topimgmr1`}><Image src='https://shengcong.sh3.ikuai7.com/ap_res/v3/1000_1777352812#sc' /></Swiper.Item>
        </Swiper>

        <div style={{
            width: '100%',
            height: '39px',
            background: '#02af6f',
            backgroundImage: 'linear-gradient(to right, #0958d9, #fff)',
            color: '#FFF',
            lineHeight: '39px',
            paddingLeft: '7px',
            fontSize: '24px',
        }}>

            防伪溯源信息
        </div>


        <AutoCenter style={{ marginTop: '20px', fontSize: '24px' }}>{params.bsm}</AutoCenter>
        <AutoCenter style={{ marginTop: '20px', fontSize: '98px' }}><MyIcon type="icon-zhengpin" className='iconclass'

        /></AutoCenter>

        <div className='fwnr'>
            您好，你所查询的是河南亨特彩铝科技有限公司出品的系列产品，品质保证，请放心使用！此防伪码已被查询{token.yz_cs}次，首次查询时间为：{token.qjson[0].fsmt}；

        </div>



        <div style={{
            marginTop: '21px',
            width: '100%',
            height: '39px',
            background: '#02af6f',
            backgroundImage: 'linear-gradient(to right, #0958d9, #fff)',
            color: '#FFF',
            lineHeight: '39px',
            paddingLeft: '7px',
            fontSize: '24px',
        }}>

            产品信息
        </div>

        <div style={{ paddingLeft: "7px" }}
        >
            <List style={{ '--font-size': '1em', '--padding-left': '0' }}>
                {token.cpjson.mjson[0] && token.cpjson.mjson[0].list.map((ea, i) => <List.Item extra={ea.second} key={i} > {` ${ea.first}`}</List.Item>
                )}
            </List>

        </div>







        <Footer label='没有更多了：此页面仅为样式示例'></Footer>


    </>
}

export default Ay26;